import { useEffect, useState } from "react";

import {
  getStats,
  getStatsByTime,
} from "../../../services/statsService";

export const useDashboardStats = () => {
  const [loading, setLoading] = useState(true);

  const [propertyStatusStats, setPropertyStatusStats] =
    useState([]);

  const [userRoleStats, setUserRoleStats] =
    useState([]);

  const [propertiesByMonth, setPropertiesByMonth] =
    useState([]);

  const [usersByMonth, setUsersByMonth] =
    useState([]);

  useEffect(() => {
    const loadDashboardData = async () => {
      try {
        const [statsData, timeData] =
          await Promise.all([
            getStats(),
            getStatsByTime(),
          ]);

        setPropertyStatusStats(
          statsData.carStatusStats || []
        );

        setUserRoleStats(
          statsData.userRoleStats || []
        );

        setPropertiesByMonth(
          timeData.carsByMonth || []
        );

        setUsersByMonth(
          timeData.usersByMonth || []
        );
      } catch (error) {
        console.error(
          "Failed to load dashboard stats:",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    loadDashboardData();
  }, []);

  return {
    loading,

    propertyStatusStats,
    userRoleStats,

    propertiesByMonth,
    usersByMonth,
  };
};